import React, { Component } from 'react'
import classes from './feadbackForm.css'
import axios from 'axios'
class Feadback extends Component {
    state = {
        formControls: {
            name: {
                type: 'text',
                label: 'ИМЯ',
                value: ''
            },
            surename: {
                type: 'text',
                label: 'ФАМИЛИЯ',
                value: ''
            },
            email: {
                type: 'email',
                label: 'E-mail',
                value: ''
            },
            subject: {
                type: 'text',
                label: 'Тема',
                value: ''
            },
            message: {
                type: 'text',
                label: 'Сообщение',
                value: ''
            }
        },
        formData: {}

    }
    componentDidMount() {
        axios.get('https://solar-energy-594b9-default-rtdb.firebaseio.com/feadback.json').then(responce => {
            console.log(responce)
        })
    }

    submitHandler = event => {
        event.preventDefault()
    }
    onChangeHandler = (event, controlName) => {
        const formControls = { ...this.state.formControls }
        const control = { ...formControls[controlName] }
        control.value = event.target.value
        formControls[controlName] = control
        let name = formControls.name.value
        let surename = formControls.surename.value
        let email = formControls.email.value
        let subject = formControls.subject.value
        let message = formControls.message.value
        const InputData = {
            name, surename, email, subject, message
        }

        this.setState({
            formControls,
            formData: InputData
        })

    }
    onClick = () => {
        axios.post('http://127.0.0.1:5000/hells', this.state.formData)
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })


    }
    clear = () => {
        document.feadbackForm.reset()

    }

    render() {
        return (
            <div className={classes.feadbackForm}>
                <div className={classes.ContactInfo}>
                    <h1>КОНТАКТЫ:</h1>
                    <h2>Телефон:</h2>
                    <h2>Email:</h2>
                    <h2>Skype:</h2>
                    <h2>WatsApp:</h2>
                </div>
                <div className={classes.inputContainer}>
                    <h1>Форма обратной связи:</h1>
                    <form onSubmit={this.submitHandler}
                        name='feadbackForm'
                    >
                        <div className='row'>
                            <div className={classes.inputBox}>
                                <label for="name">ИМЯ <span class="req">*</span></label>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    class={classes.Input}
                                    tabIndex="1"
                                    placeholder="Иван" required
                                    onChange={(event) => this.onChangeHandler(event, 'name')}
                                >
                                </input>
                            </div>

                        </div>

                        <div className='row'>
                            <div className={classes.inputBox}>
                                <label for="surename">ФАМИЛИЯ <span class="req">*</span></label>
                                <input type="text"
                                    name="surename"
                                    id="surename"
                                    class={classes.Input}
                                    tabIndex="2"
                                    placeholder="Иванов" required
                                    onChange={(event) => this.onChangeHandler(event, 'surename')}
                                ></input>
                            </div>

                        </div>
                        <div className='row'>
                            <div className={classes.inputBox}></div>
                            <label for="email">E-mail  <span class="req">*</span></label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                class={classes.Input}
                                tabIndex="3"
                                placeholder=" address@mail.ru" required
                                onChange={(event) => this.onChangeHandler(event, 'email')}
                            ></input>
                        </div>
                        <div className='row'>
                            <div className={classes.inputBox}>
                                <label for="subject">Тема <span class="req">*</span></label>
                                <input
                                    type="text"
                                    name="subject"
                                    id="subject"
                                    class={classes.Input}
                                    tabIndex="4"
                                    placeholder="Тема письма" required
                                    onChange={(event) => this.onChangeHandler(event, 'subject')}
                                ></input>
                            </div>

                        </div>
                        <div className='row'>
                            <div className={classes.inputBox}>
                                <label for="message">Сообщение <span class="req">*</span></label>
                                <textarea name="message"
                                    id="message"
                                    class="txtarea"
                                    tabindex="5" required
                                    onChange={(event) => this.onChangeHandler(event, 'message')}
                                ></textarea>
                            </div>

                        </div>
                        <div className={classes.buttonMenu}>
                            <button onClick={this.onClick} ><a className={classes.modalA} href="#openModal">Отправить </a> </button>
                            <button onClick={this.clear}>Очистить</button>
                            <div className={classes.formComplete}>
                                <div className={classes.modalDialog} id='openModal' >
                                    <div>
                                        <a href="#close" title="Закрыть" className="close">X</a>
                                        <h2 className={classes.modalH2}>Благодарим за обратную связь!</h2>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </form>
                </div>
            </div>
        )

    }
}
export default Feadback


// WEBPACK FOOTER //
// ./src/containers/Feadback Form/feadbackForm.js